const awsExports = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_G5RGJadbv",
    "aws_user_pools_web_client_id": "7e9pd445drjutau2siqid7qkrb"
}

export default awsExports;